<div class="main-container">
  <div class="img-container">
    <img src="/assets/branded/img/feedback-bg.png" [alt]="'common.alt-image' | transloco" />
  </div>
  <div class="content">
    <ng-container *ngTemplateOutlet="activeTemplate"></ng-container>
    <ion-footer class="ion-no-border">
      <ion-toolbar>
        <div class="close">
          <c-button type="secondary" [disabled]="submitting$ | async" (action)="close()" data-test-id="rate-app-component.close-popup.button">
            {{ 'common.close' | transloco }}
          </c-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </div>
</div>

<ng-template #like>
  <div class="like">
    <div class="title">{{ 'feedback.application.like-app' | transloco }}</div>
    <div class="cta">
      <c-button
        [loading]="submitting$ | async"
        [disabled]="submitting$ | async"
        (action)="likeTheApp()"
        data-test-id="rate-app-component.like-app.button">
        {{ 'common.yes' | transloco }}
      </c-button>
      <c-button
        type="secondary"
        [disabled]="submitting$ | async"
        (action)="goTo(rateAppTemplates.Feedback)">
        {{ 'common.no' | transloco }}
      </c-button>
    </div>
  </div>
</ng-template>

<ng-template #rate>
  <div class="rate">
    <div class="title">{{ 'feedback.application.leave-review' | transloco }}</div>
    <c-button (action)="openAppStore()">{{ 'common.yes' | transloco }}</c-button>
  </div>
</ng-template>

<ng-template #feedback>
  <div class="feedback" [formGroup]="form">
    <div class="title">{{ 'feedback.application.sorry.title' | transloco }}</div>
    <div class="description">{{ 'feedback.application.sorry.description' | transloco }}</div>
    <c-textarea
      formControlName="feedbackText"
      [maxLength]="maxLength"
      [label]="'feedback.share' | transloco"
      [placeholder]="'feedback.share' | transloco"
    ></c-textarea>
    <div class="cta">
      <c-button
        [loading]="submitting$ | async"
        [disabled]="submitting$ | async"
        (action)="dislikeTheApp()"
        data-test-id="rate-app-component.dislike-app.button">
        {{ 'common.send' | transloco }}
      </c-button>
    </div>
  </div>
</ng-template>
